export default __webpack_public_path__ + "static/84-2d507867952f92f567dd23b8e90c2303.png";